/**
 * Created by CoolGuy on 2017/4/11.
 */
import React from 'react';
import {connect} from 'react-redux';
import {Card,Button,Input,message} from 'antd';
import Check from "../../util/CheckList";
import AjaxAction from '../../actions/AjaxAction';
import URL from '../../util/url.js';
import { isWeb, unique, isElectron} from '../../util/index.js';

class Login extends React.Component{

    state = {
        username:window.sessionStorage.getItem('username') || "",
        password:""
    };
    loginEnable = true;
    login = ()=>{
        if(!this.loginEnable){
            return;
        }

        let {username,password} = this.state;
        let {dispatch,router} = this.props;
        let _this = this;
        if(Check.username(username)/* && Check.password(password)*/){
            _this.loginEnable = false;
            dispatch(AjaxAction.login(username,password)).then((data)=>{
                window.sessionStorage["token"] = data.token;
                window.sessionStorage["nickname"] = data.nickname;
                window.sessionStorage['userId'] = data.id;
                window.sessionStorage['permissions'] = data.permissions;
                window.sessionStorage['photo'] = data.photo;
                window.sessionStorage['oper'] = data.oper;
                _this.loginEnable=true;

                if(isElectron() && typeof window.remoteStoreSession == 'function') {
                  window.remoteStoreSession({
                    token:data.token,
                    nickname:data.nickname,
                    username:this.state.username,
                    userId:data.id,
                    permissions:data.permissions,
                    photo:data.photo,
                    oper:data.oper,
                    password:this.state.password
                  });
                }

                message.success("登录成功,正在跳转",1,()=>{
                    window.sessionStorage.setItem('username', username);
                    // window.location.href = '/page/dashboard';
                    var current = new URL(window.location.href);
                    let {redirect} = current.query || {};
                    if(redirect && redirect.indexOf('login') < 0) {
                        window.location.href = decodeURIComponent(redirect);
                    }else {
                        // this.props.router.history.replace('/page/dashboard');
                        window.location.href = '/page/dashboard';
                    }
                    // dispatch(AjaxAction.permissionUserAuthList()).then(()=>{
                    //
                    // });

                });
            }).catch((e)=>{
                _this.loginEnable=true;
                throw e;
            });
        }else{
            message.warn("请输入正确的用户名/密码");
        }
    };

    componentDidMount() {
      if(!isWeb()) {
          document.querySelector('#root').className = 'mobile';
      }

      if(isElectron()) {
        window.addEventListener('electron-manager', (e)=>{
          let {data} = e;
          if(data.username) {
            this.setState({
              username:data.username
            });
          }
          if(data.password) {
            this.setState({
              password:data.password
            })
          }
        });

        if(typeof window.checkStoreSession == 'function') {
          window.checkStoreSession();
        }
      }
    }

    render(){
        let redirect = encodeURIComponent(`http://admin.jfoto.cn`);
        let fxiaoRedirect = `https://open.fxiaoke.com/oauth2/authorize?appId=FSAID_1317db7&redirectUri=${redirect}&responseType=code&scope=login_bind&state=fromfxiao${Date.now()}`;

        return (
            <div style={{width:500,margin:"10% auto"}}>
                <Card title="登录">
                    <div>
                        用户名:<Input placeholder="请输入用户名" value={this.state.username} onChange={(e)=>{this.setState({username:e.target.value})}}/>
                    </div>
                    <div>
                        密码:<Input placeholder="请输入密码" type="password"  value={this.state.password} onPressEnter={this.login} onChange={(e)=>{this.setState({password:e.target.value})}}/>
                    </div>
                    <div style={{marginTop:10,display:"flex",alignItems:"center"}}>
                        <Button type="primary" onClick={this.login}>登录</Button>
                        {<a href={fxiaoRedirect} style={{flex:1,textAlign:"right"}}>纷享销客登录</a>}
                    </div>
                </Card>
            </div>
        )
    }
}

export default connect()(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js